import { useMemo } from "react";
import { usePunditUserContext } from "../contexts";
import { isCommunityAdmin } from "../helpers/communityMemberHelpers";

export const useChecklistAvailable = () => {
  const { onboardingFlags, currentCommunityMember } = usePunditUserContext();

  const isChecklistAvailable = useMemo(() => {
    if (!currentCommunityMember || !isCommunityAdmin(currentCommunityMember)) {
      return false;
    }
    return !onboardingFlags?.getting_started_checklist_hidden;
  }, [onboardingFlags, currentCommunityMember]);

  return {
    isChecklistAvailable,
  };
};
